import { render, staticRenderFns } from "./apaging.vue?vue&type=template&id=2d619870&scoped=true"
import script from "./apaging.vue?vue&type=script&lang=js"
export * from "./apaging.vue?vue&type=script&lang=js"
import style0 from "./apaging.vue?vue&type=style&index=0&id=2d619870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d619870",
  null
  
)

export default component.exports